'use strict';

import { createVueInstance } from './helpers/vue-instance';
import { removeSubscription } from './_vue-functions';

createVueInstance({
	el: '[data-init="watchlist"]',
	delimiters: ['$({', '})'],
	methods: {
		removeFromWatchList: removeSubscription,
	}
});
